export default "__VITE_ASSET__C$wMvZu$__"